<script>
  export default {
    props: {
      open: {
        type: Boolean,
        default: false,
      },
      // Prismic field: promo_headline / promo_headline_b
      headline: {
        type: String,
        default: '',
      },
      // Prismic field: promo_subhead / promo_subhead_b
      subhead: {
        type: String,
        default: '',
      },
      // Prismic field: promo_cta_text / promo_cta_text_b
      ctaText: {
        type: String,
        default: 'Learn More',
      },
      // Prismic field: promo_cta_url / promo_cta_url_b
      ctaUrl: {
        type: String,
        default: '',
      },
      // Prismic field: promo_dismiss_text
      dismissText: {
        type: String,
        default: 'No thanks, maybe later',
      },
    },
  }
</script>

<template>
  <Portal to="modal">
    <BaseModal
      size="sm-md"
      bg-color="dawn"
      dismissible
      sticky-icon
      :open="open"
      @dismiss="$emit('dismiss')"
    >
      <div class="flex flex-col items-center text-center px-2 py-2">
        <div class="font-heading text-center mb-5">
          <div class="font-semibold text-2xl md:text-3xl leading-tight max-w-xs mx-auto">
            {{ headline }}
          </div>
        </div>
        <p class="text-sm md:text-base max-w-sm mx-auto mb-8">
          {{ subhead }}
        </p>
        <a
          :href="ctaUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="w-full max-w-xs block"
          @click="$emit('dismiss')"
        >
          <BaseButton class="w-full">{{ ctaText }}</BaseButton>
        </a>
        <button
          class="mt-4 text-sm underline focus:outline-none"
          @click="$emit('dismiss')"
        >
          {{ dismissText }}
        </button>
      </div>
    </BaseModal>
  </Portal>
</template>
